<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="col-wrapper">
  <div *ngIf="d3ePolicy" class="policy-settings-wrapper">
      <div *ngIf="show_force_policy_checkbox && haveDDTier" class="settings-row force-policy-row" [attr.inert]="haveDDTier ? null : ''">
          <span id="override-device-policy" class="setting-label" aria-label="Override device policy">
              {{'OVERRIDE_DEVICE_POLICY' | translate}}
              <span matTooltip="{{'OVERRIDE_DEVICE_POLICY' | translate}}" matTooltipPosition="right">
                  <span class="mdi mdi-information-outline circle-info-icon"></span>
              </span>
          </span>
          <span class="toggle-adjustment">
              <span class="toggle-setting-value" (click)="onPolicyToggleChange(false)" [ngClass]="{'off-active': !forcePolicyRemoval, 'off-inactive': forcePolicyRemoval}">Off</span>
              <mat-slide-toggle
                  aria-labelledby="override-device-policy"
                  color="primary"
                  [disableRipple]="true"
                  (change)="onPolicyToggleChange($event.checked)"
                  [checked]="forcePolicyRemoval">
              </mat-slide-toggle>
              <span class="toggle-setting-value" (click)="onPolicyToggleChange(true)" [ngClass]="{'on-active': forcePolicyRemoval, 'on-inactive': !forcePolicyRemoval}">On</span>
          </span>
      </div>
      @if (haveDDTier) {
          <div class="settings-row force-policy-row" [attr.inert]="haveDDTier ? null : ''">
              <span id="always-on" class="setting-label" aria-label="Allow 'Always On' file type protection">
                  {{'ALLOW_ALWAYS_ON' | translate}}
                  <span tabindex="0"
                        aria-label="Enable to allow file extensions to be set to 'Always On' in the File Type Protection pages.
                                  Use of 'Always On' extensions can cause some applications to not run as expected. If disabled,
                                  any 'Always On' extensions will be changed to Dynamic."
                      matTooltip="{{'ALLOW_ALWAYS_ON' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <span class="toggle-adjustment" matRipple [attr.inert]="haveDDTier ? null : ''">
                  <span class="toggle-setting-value" (click)="onAlwaysOnToggleChange(false)" [ngClass]="{'off-active': !allowAlwaysOn, 'off-inactive': allowAlwaysOn}">
                      {{'OFF' | translate}}
                  </span>
                  <mat-slide-toggle
                      aria-labelledby="always-on"
                      #alwaysOnToggleElement
                      color="primary"
                      [disableRipple]="true"
                      (change)="onAlwaysOnToggleChange($event.checked)"
                      [checked]="allowAlwaysOn">
                  </mat-slide-toggle>
                  <span class="toggle-setting-value" (click)="onAlwaysOnToggleChange(true)" [ngClass]="{'on-active': allowAlwaysOn, 'on-inactive': !allowAlwaysOn}">
                      {{'ON' | translate}}
                  </span>
              </span>
          </div>
      }
      <div class="settings-row">
          <span id="sync-interval" class="setting-label">
              {{'SYNC_INTERVAL' | translate}}
              <span tabindex="0"
                    aria-label="The Sync interval setting controls how often a device will make calls to synchronize its settings with this policy."
                    matTooltip="{{'SYNC_INTERVAL_TOOLTIP' | translate}}"
                    matTooltipPosition="right">
                  <span class="mdi mdi-information-outline circle-info-icon"></span>
              </span>
          </span>
          <span class="interval-selectors-row">
              <mat-form-field appearance="outline" class="interval-form-field">
                <mat-select [value]="getSyncInterval()" (selectionChange)="onSyncIntervalChanged($event.value)"
                            hideSingleSelectionIndicator="true">
                  @for (timeValue of timeValues; track timeValue) {
                    <mat-option [value]="timeValue">{{timeValue}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="interval-unit-form-field">
                <mat-select [value]="syncIntervalUnit" (selectionChange)="onSyncIntervalUnitChanged($event.value)"
                            hideSingleSelectionIndicator="true">
                  @for (timeUnit of timeUnits; track timeUnit) {
                    <mat-option [value]="timeUnit">{{timeUnit}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
          </span>
      </div>
      <div class="settings-row">
          <span id="sync-interval-metered" class="setting-label">
              {{'SYNC_INTERVAL_METERED' | translate}}
              <span tabindex="0"
                  aria-label="How often a device will make calls to synchronize its settings with this policy when on a metered network."
                  matTooltip="{{'SYNC_INTERVAL_METERED_TIP' | translate}}"
                  matTooltipPosition="right">
                  <span class="mdi mdi-information-outline circle-info-icon"></span>
              </span>
          </span>
          <span class="interval-selectors-row">
              <mat-form-field appearance="outline" class="interval-form-field">
                <mat-select [value]="getSyncIntervalMetered()" (selectionChange)="onSyncIntervalMeteredChanged($event.value)"
                            hideSingleSelectionIndicator="true">
                  @for (timeValueMetered of timeValuesMetered; track timeValueMetered) {
                    <mat-option [value]="timeValueMetered">{{timeValueMetered}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="interval-unit-form-field">
                <mat-select [value]="syncIntervalMeteredUnit" (selectionChange)="onSyncIntervalMeteredUnitChanged($event.value)"
                            hideSingleSelectionIndicator="true">
                  @for (timeUnitMetered of timeUnitsMetered; track timeUnitMetered) {
                    <mat-option [value]="timeUnitMetered">{{timeUnitMetered}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
          </span>
      </div>
      @if (haveDDTier) {
          <div class="settings-row" *ngIf="showFileAccessCount">
            <hr>
          </div>
          <div class="settings-row double" *ngIf="showFileAccessCount" [attr.inert]="haveDDTier ? null : ''">
              <span id="pre-auth-file-access-count" class="setting-label">
                  {{'PRE_AUTH_FILE_ACCESS_COUNT' | translate}}
                  <span tabindex="0"
                      aria-label="After a successful authentication, the number of files allowed to be accessed without
                      additional authentication."
                      matTooltip="{{'PRE_AUTH_FILE_ACCESS_COUNT_TOOLTIP' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <span class="frequency-wrapper">
                  <label class="min-file-frequency-label">0</label>
                  <mat-slider
                      id="re-auth-frequency-slider"
                      class="timeout-slider"
                      [max]="100"
                      [min]="0"
                      [step]="1"
                      aria-labelledby="example-name-label" #ngSlider><input matSliderThumb [value]="selectedFileFrequency" (input)="onFileFrequencyChanged(ngSliderThumb.value)" #ngSliderThumb="matSliderThumb" />
                  </mat-slider>
                  <label class="max-file-frequency-label">100</label>
                  <span class="file-frequency-input-wrapper">
                    <app-numeric-input
                        id="file-frequency-count-input"
                        [inputStyles]="inputStyles"
                        [inputLabelStyles]="inputFrequencyLabelStyles"
                        [min]="0"
                        [max]="100"
                        step="1"
                        [value]="selectedFileFrequency"
                        [showProgressBar]="false"
                        labelPosition="right"
                        inputPosition="right"
                        label="{{'FILES' | translate}}"
                        [showMinMax]="false"
                        [disabled]="false"
                        (valueChanged)="onFileFrequencyChanged($event)">
                    </app-numeric-input>
                  </span>
              </span>
          </div>
          <div class="timeout-options" *ngIf="showFileAccessCount" [attr.inert]="haveDDTier ? null : ''">
            <div class="settings-row">
              <span id="pre-auth-file-access-timeout" class="setting-label"></span>
              <span class="select-timeout-wrapper">
                  <span class="frequency-over-time-label">
                    <span class="mdi mdi-arrow-right-bottom arrow-right-bottom"></span>
                    <label class="over-label">{{'OVER' | translate}}</label>
                    <span class="mdi mdi-arrow-down-right arrow-down-right"></span>
                  </span>
                  <label class="min-frequency-timeout-label">{{'PRE_AUTH_10_MINUTES_TIMEOUT' | translate}}</label>
                  <mat-slider
                      id="timeout-slider"
                      class="timeout-slider"
                      [max]="6"
                      [min]="1"
                      [step]="1"
                      aria-labelledby="timeout-label" #ngSlider><input matSliderThumb [value]="selectedTimeout" (input)="onSelectionTimeoutChanged({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value)" #ngSliderThumb="matSliderThumb" />
                  </mat-slider>
                <label class="max-frequency-timeout-label">{{'UNLIMITED' | translate}}</label>
                <span class="file-frequency-input-wrapper">
                  <app-numeric-input
                      id="file-frequency-timeout-input"
                      [inputStyles]="inputStyles"
                      [inputLabelStyles]="inputFrequencyLabelStyles"
                      [min]="0"
                      [max]="30"
                      step="1"
                      [disabled]="true"
                      [value]="getTimeValueFromTimeout(selectedTimeout)"
                      [showProgressBar]="false"
                      labelPosition="right"
                      inputPosition="right"
                      label="{{getFreqTimeoutLabel(selectedTimeout)}}"
                      [showMinMax]="false">
                  </app-numeric-input>
                </span>

              </span>
            </div>
          </div>
          <div class="settings-row checkmark-row" *ngIf="showFileAccessCount" [attr.inert]="haveDDTier ? null : ''">
              <span id="pre-auth-absolute-or-maximum" class="setting-label">
                  {{'FORCE_PRE_AUTH_VALUES_DESC' | translate}}
                  <span tabindex="0"
                      attr.aria-label="{{'FORCE_PRE_AUTH_VALUES_TOOLTIP' | translate}}"
                      matTooltip="{{'FORCE_PRE_AUTH_VALUES_TOOLTIP' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <span class="re-auth-frequency-wrapper">
                <mat-form-field appearance="outline">
                    <mat-select [value]="selectedReAuthFrequency.valueOf()"
                                (selectionChange)="onReAuthFrequencyChange($event.value)"
                                class="select-input" [disableOptionCentering]="true" [disableRipple]="true"
                                aria-labelledby="">
                        <mat-option *ngFor="let option of reAuthFrequencyOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </span>
          </div>

          <div class="settings-row" *ngIf="showRansomware"><hr></div>
          <div class="settings-row" *ngIf="showRansomware" [attr.inert]="haveDDTier ? null : ''">
              <span id="ransomware-sensitivity" class="setting-label">
                  {{'policy.ransomware.sensitivity' | translate}}
                  <span tabindex="0"
                      aria-label="Set the ransomware sensitivity."
                      matTooltip="{{ 'policy.ransomware.sensitivity-tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <span class="custom-slider">
                <span style="display: flex; justify-content: flex-start; align-items: center; gap: 5px;">
                  <label style="min-width: 60px;">Min {{ ransomwareSensitivityMin }}</label>
                  <mat-slider min="1" max="100" [discrete]="true">
                    <input [(ngModel)]="ransomwareSensitivityMin" (valueChange)="onSliderMinValueChange($event)" matSliderStartThumb>
                    <input [(ngModel)]="ransomwareSensitivityMax" (valueChange)="onSliderHighValueChange($event)" matSliderEndThumb>
                  </mat-slider>
                  <label style="min-width: 60px;">Max {{ ransomwareSensitivityMax }}</label>
                </span>
              </span>
          </div>
          <div class="ransomware-options" *ngIf="showRansomware" [attr.inert]="haveDDTier ? null : ''">
            <div class="settings-row">
              <span id="ransomware-feature-mask" class="setting-label">
                  {{'policy.ransomware.feature-mask.label' | translate}}
                  <span tabindex="0"
                      aria-label="Number of minutes to allow automatic authorization."
                      matTooltip="{{ 'policy.ransomware.feature-mask.tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <span class="ransomware-detection-wrapper">
                <mat-form-field appearance="outline">
                    <mat-select [value]="selectedFeatureMask.valueOf()" (selectionChange)="onRansomwareFeatureMaskChange($event.value)"
                                class="select-input" [disableOptionCentering]="true" [disableRipple]="true"
                                aria-labelledby="">
                        <mat-option *ngFor="let option of ransomware_mask_options" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </span>
            </div>
          </div>

          <div class="settings-row"><hr></div>

          <div *ngIf="false" class="settings-row" [attr.inert]="haveDDTier ? null : ''">
              <span id="import-policy" class="setting-label">
                  {{'IMPORT_POLICY' | translate}}
                  <span tabindex="0"
                      aria-label="Import the policy from the selected device."
                      matTooltip="{{'IMPORT_POLICY_TOOLTIP' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline circle-info-icon"></span>
                  </span>
              </span>
              <div>
                <mat-form-field  appearance="outline">
                    <mat-label>{{'SELECTED_DEVICE' | translate}}</mat-label>
                    <mat-select (selectionChange)="onSelectionImportChanged($event.value)" class="select-input" [disableOptionCentering]="true" [disableRipple]="true"
                            aria-labelledby="import-policy">
                        <mat-option *ngFor="let device of devices" [value]="device" [disabled]="device.id === -100">
                            {{ device.computer_name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
              <span class="policy-button">
                  <button mat-stroked-button (click)="onLoad()">{{'IMPORT' | translate}}</button>
              </span>
          </div>
          <span *ngIf="false">
              <h3 class="d3e-settings-label">{{'D3E_SETTINGS' | translate}}</h3>
              <mat-divider></mat-divider>
              <div *ngFor="let sensorType of sensorTypes;" class="sensor-wrapper">
                  <label class="sensor-label">{{sensorType.description || sensorType.displayValue}}</label>
                  <span class="policy-toggle-button-group">
                      <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="getSensorToggleState(sensorType.value)" name="policy-toggle-button-group" (change)="onSensorToggleChanged($event, sensorType.value)">
                          <mat-button-toggle id="2-{{sensorType.value}}" value="2-{{sensorType.value}}" disableRipple="true" [checked]="true">{{'LOCAL' | translate}}</mat-button-toggle>
                          <mat-button-toggle id="0-{{sensorType.value}}" value="0-{{sensorType.value}}" disableRipple="true">{{'OFF' | translate}}</mat-button-toggle>
                          <mat-button-toggle id="1-{{sensorType.value}}" value="1-{{sensorType.value}}" disableRipple="true">{{'ON' | translate}}</mat-button-toggle>
                      </mat-button-toggle-group>
                  </span>
              </div>
          </span>
      }
  </div>
  @if (haveDDTier) {
      <div class="button-col" [attr.inert]="haveDDTier ? null : ''">
          <span tabindex="0">
              <button mat-stroked-button color="primary" class="set-recommend-button" (click)="onSetRecommendedClick()">
                  {{'RECOMMENDED_BUTTON' | translate}}
              </button>
          </span>
      </div>
  }
</div>
